<template>
    <div
        :class="$style.container"
        @click.prevent="emit('click')"
    >
        <Button
            interfaceTarget="close-game-mobile-button"
            size="s"
            :class="$style.button_override"
            @click.stop="emit('closeGame')"
        >
            <div :class="$style.content">
                <Icon
                    name="chevron-left"
                    :class="$style.icon_override"
                />
                <Typography
                    v-if="props.hideBranding"
                    type="label"
                    size="s"
                    accent
                    :responsive="false"
                >
                    {{ $tr('gameContainer.back') }}
                </Typography>
                <Logo
                    v-else
                    mode="default"
                    :class="$style.logo_override"
                />
            </div>
        </Button>
        <Typography
            type="label"
            size="s"
            accent
            :responsive="false"
            :class="$style.title"
        >
            {{ props.title }}
        </Typography>
        <Button
            v-if="!props.isAdFreeActive && !props.hideBranding && appStore.isPurchaseEnabled"
            color="carbon-400"
            interfaceTarget="no-ads-mobile-button"
            size="s"
            :class="$style.no_ads_button_override"
            :label="$tr('gameContainer.noAds')"
            @click="emit('noAdsClick')"
        />
    </div>
</template>

<script lang="ts" setup>
import Button from '@/components/Buttons/Button.vue'
import Icon from '@/components/Icon/Icon.vue'
import Logo from '@/components/Logo.vue'
import Typography from '@/components/Typography.vue'
import { useAppStore } from '@/store/app-store'

const emit = defineEmits<{
    closeGame: []
    click: []
    noAdsClick: []
}>()

const props = defineProps<{
    title: string
    isAdFreeActive: boolean
    hideBranding?: boolean
}>()

const appStore = useAppStore()
</script>

<style module>
.container {
    display: flex;
    align-items: center;
    gap: 8px;
    background-color: var(--black);
    padding: 6px;
    height: var(--mobile-top-bar-height);
    box-sizing: border-box;
    overflow: hidden;
}

.button_override {
    padding: 8px 10px 8px 4px;
}

.content {
    display: flex;
    align-items: center;
}

.icon_override {
    width: 16px;
    height: 16px;
}

.logo_override {
    width: 60px;
}

.title {
    color: var(--white-60);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.no_ads_button_override {
    margin-left: auto;
    margin-right: var(--pg-safe-area-right);
}
</style>
